module.exports = __webpack_public_path__ + "img/line.d9ed6cf6.png";